import React from "react";

const MatchmakerLogo = ({ size = 30 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M17 34 C12 30 6 26 6 20 C6 16 9 13 12.5 13 C15 13 16.2 14.2 17 15.5 C17.8 14.2 19 13 21.5 13 C25 13 28 16 28 20 C28 26 22 30 17 34 Z"
      stroke="#E54B3C"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M31 34 C26 30 20 26 20 20 C20 16 23 13 26.5 13 C29 13 30.2 14.2 31 15.5 C31.8 14.2 33 13 35.5 13 C39 13 42 16 42 20 C42 26 36 30 31 34 Z"
      stroke="#E54B3C"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <circle cx="24" cy="21" r="2.2" fill="#E54B3C" />
  </svg>
);

export default MatchmakerLogo;
